module.exports = __webpack_public_path__ + "img/HU.11805384.svg";